import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { environment } from '@environments/environment';
import packageJson from '../../../../package.json';

@Injectable()
export class TranslationLoaderService implements TranslateLoader {
    constructor(private http: HttpClient) { }

    public getTranslation(lang: string): any {
        // Always make translate request to PO editor, if any error, get local translate files. PGN-2797
        const url = environment.domain_config_gw_api + `/services/language/translate?platform=web&language=${lang}&appVersion=${packageJson.version}`;
        return this.http.get(url).pipe(
            map((data) => data),
            catchError(() => this.http.get('/assets/i18n/' + lang + '.json'))
        );
    }
}
